<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'

import { nextTick, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const props = withDefaults(defineProps<{
  title: string
  subtitle?: string
  showBackButton?: boolean
  disableBackButton?: boolean
  backRoute?: RouteLocationRaw
}>(), {
  showBackButton: true,
  disableBackButton: false,
})

const router = useRouter()
const route = useRoute()

const title = ref(props.title)
const subtitle = ref(props.subtitle)
const finalizedDisableBackButton = ref(props.disableBackButton)

watch([() => props.title, () => props.subtitle, route], async () => {
  await nextTick()

  finalizedDisableBackButton.value = props.disableBackButton
  title.value = props.title
  subtitle.value = props.subtitle
})
</script>

<template>
  <div
    :style="{
      top: 'env(safe-area-inset-top, 0px)',
      right: 'env(safe-area-inset-right, 0px)',
      left: 'env(safe-area-inset-left, 0px)',
    }"
    sticky inset-x-0 top-0 z-99 pb-6 pt-10
    flex="~ row items-center gap-2"
    bg="$bg-color"
    class="w-[calc(100%+1.5rem)] px-3 -mx-3 xl:w-[calc(100%+2rem)] xl:px-4 xl:-mx-4"
  >
    <button @click="props.backRoute ? router.push(props.backRoute) : router.back()">
      <div
        v-if="!finalizedDisableBackButton"
        i-solar:alt-arrow-left-line-duotone text-2xl
        :class="{ 'pointer-events-none op-0': !showBackButton }"
      />
    </button>
    <h1 relative>
      <div v-if="subtitle" absolute left-0 top-0 translate-y="[-80%]">
        <span text="neutral-300 dark:neutral-500" text-nowrap>{{ subtitle }}</span>
      </div>
      <div text-nowrap text-3xl font-normal>
        {{ title }}
      </div>
    </h1>
  </div>
</template>
